<template>
    <div class="patrimonio-dashboard">
        <div class="row">
            <div class="col-md-12 grid-margin">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-3 col-md-6 mt-md-0 mt-4">
                                <lg-status-card :value="dashboardData.quantidadeProcessosCompraEmAndamento || 0" label="Processos de compra" sublabel="Em andamento" variant="info" icon="diagram3" />
                            </div>
                            <div class="col-lg-3 col-md-6 mt-md-0 mt-4">
                                <lg-status-card :value="dashboardData.quantidadeEmpenhoVigente || 0" label="Empenhos vigentes" sublabel="Ativos" variant="primary" icon="file-earmark-text" />
                            </div>
                            <div class="col-lg-3 col-md-6 mt-md-0 mt-4">
                                <lg-status-card :value="formatCurrency(dashboardData.valorTotalPatrimonio)" label="Valor total" sublabel="Patrimônio" variant="success" icon="currency-dollar" />
                            </div>
                            <div class="col-lg-3 col-md-6 mt-md-0 mt-4">
                                <lg-status-card :value="getTotalQuantidadePorNaturezaDespesa()" label="Total de itens" sublabel="Cadastrados" variant="warning" icon="collection" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-8 grid-margin stretch-card">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title mb-0">Quantidade Comprada por Natureza de Despesa</h4>
                        <div class="d-flex flex-column flex-lg-row">
                            <p>Visualize a quantidade de itens comprados por Natureza de Despesa</p>
                            <div class="filter-wrapper ml-lg-auto d-flex">
                                <select class="form-control form-control-local form-control-sm" v-model="selectedYear"
                                    @change="filterByYear">
                                    <option v-for="year in availableYears" :key="year" :value="year">{{ year }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="chart-container mt-4" style="height:520px;">
                            <canvas id="naturezaDespesaChart"></canvas>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4 grid-margin stretch-card">
                <div class="card">
                    <div class="card-body d-flex flex-column">
                        <div class="wrapper">
                            <h4 class="card-title mb-0">Situação dos Itens</h4>
                            <p>Distribuição por situação</p>
                            <div class="mb-4" id="situacao-legend">
                                <div class="chartjs-legend">
                                    <ul>
                                        <li><span style="background-color:rgba(75, 192, 192, 0.6)"></span>Ativo</li>
                                        <li><span style="background-color:rgba(255, 99, 132, 0.6)"></span>Inativo</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="chart-container my-auto mx-auto" style="height: 260px; width: 100%;">
                            <canvas id="situacaoChart"></canvas>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Chart from 'chart.js';
import ResourceService from "@/core/api/ResourceService";
import LgStatusCard from "@/core/components/Cards/LgStatusCard.vue";

export default {
    name: 'PatrimonioDashboard',
    components: { LgStatusCard },
    data() {
        return {
            dashboardData: {
                quantidadeProcessosCompraEmAndamento: 0,
                quantidadeEmpenhoVigente: 0,
                valorTotalPatrimonio: 0,
                quantidadePorNaturezaDespesa: [],
                quantidadePorNaturezaDespesaAno: [],
                quantidadePorSitucao: {}
            },
            selectedYear: new Date().getFullYear(),
            availableYears: [],
            processosCompraChart: null,
            empenhoLineChart: null,
            valorLineChart: null,
            itensLineChart: null,
            naturezaDespesaChart: null,
            situacaoChart: null,
            chartColors: [
                'rgba(75, 192, 192, 0.6)',
                'rgba(255, 99, 132, 0.6)',
                'rgba(255, 206, 86, 0.6)',
                'rgba(54, 162, 235, 0.6)',
                'rgba(153, 102, 255, 0.6)',
                'rgba(255, 159, 64, 0.6)',
                'rgba(199, 199, 199, 0.6)',
                'rgba(83, 102, 255, 0.6)',
                'rgba(40, 159, 64, 0.6)',
                'rgba(210, 199, 199, 0.6)'
            ],
            chartBorderColors: [
                'rgba(75, 192, 192, 1)',
                'rgba(255, 99, 132, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)',
                'rgba(199, 199, 199, 1)',
                'rgba(83, 102, 255, 1)',
                'rgba(40, 159, 64, 1)',
                'rgba(210, 199, 199, 1)'
            ]
        };
    },
    beforeMount() {
        this.$service = new ResourceService("/api/itembempermanente-dashboard");

        for (let year = 1900; year <= 2099; year++) {
            this.availableYears.push(year);
        }

        this.loadDashboard();
    },
    methods: {
        async loadDashboard() {
            try {
                const response = await this.$service.findAll({
                    page: 1,
                    size: 1000,
                    params: { year: this.selectedYear }
                });
                this.dashboardData = response.data;
                this.initCharts();
                this.initSmallCharts();
            } catch (error) {
                this.$notify({
                    type: "danger",
                    message: error.response.data
                });
            }
        },

        filterByYear() {
            this.loadDashboard();
        },

        getTotalQuantidadePorNaturezaDespesa() {
            if (!this.dashboardData.quantidadePorNaturezaDespesa) return 0;
            return this.dashboardData.quantidadePorNaturezaDespesa.reduce((total, item) => total + item.quantidade, 0);
        },

        exportToPDF() {
            this.$notify({
                type: 'info',
                message: 'Exportação para PDF será implementada em breve'
            });
        },

        exportToExcel() {
            this.$notify({
                type: 'info',
                message: 'Exportação para Excel será implementada em breve'
            });
        },

        initCharts() {
            this.initNaturezaDespesaChart();
            this.initSituacaoChart();
        },

        initSmallCharts() {
            this.initProcessosCompraChart();
            this.initEmpenhoLineChart();
            this.initValorLineChart();
            this.initItensLineChart();
        },

        initNaturezaDespesaChart() {
            const ctx = document.getElementById('naturezaDespesaChart');
            if (!ctx) return;

            if (this.naturezaDespesaChart) {
                this.naturezaDespesaChart.destroy();
            }

            let data = [];
            let labels = [];
            let values = [];
            let title = 'Quantidade por Natureza de Despesa';

            if (this.dashboardData.quantidadePorNaturezaDespesaAno && this.dashboardData.quantidadePorNaturezaDespesaAno.length > 0) {
                data = this.dashboardData.quantidadePorNaturezaDespesaAno || [];
                labels = data.map(item => item.descricaoNatureza);

                values = data.map(item => {
                    const yearData = item.quantidadePorAno[this.selectedYear];
                    return yearData || 0;
                });

                title = `Quantidade por Natureza de Despesa em ${this.selectedYear}`;
            } else {
                data = this.dashboardData.quantidadePorNaturezaDespesa || [];
                labels = data.map(item => item.descricaoNatureza);
                values = data.map(item => item.quantidade);
            }

            this.naturezaDespesaChart = new Chart(ctx, {
                type: 'bar',
                data: {
                    labels: labels,
                    datasets: [{
                        label: 'Quantidade',
                        data: values,
                        backgroundColor: this.chartColors.slice(0, data.length),
                        borderColor: this.chartBorderColors.slice(0, data.length),
                        borderWidth: 1,
                        categoryPercentage: 0.7,
                        barPercentage: 0.8
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    title: {
                        display: true,
                        text: title
                    },
                    legend: { display: false },
                    tooltips: {
                        mode: 'nearest',
                        intersect: true,
                        callbacks: {
                            title: (items, data) => data.labels[items[0].index] || '',
                            label: (item) => `Quantidade: ${item.yLabel}`
                        }
                    },
                    scales: {
                        xAxes: [{
                            ticks: {
                                autoSkip: true,
                                maxRotation: 0,
                                callback: (value) => this.truncateLabel(value)
                            }
                        }],
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                stepSize: 1,
                                precision: 0
                            }
                        }]
                    }
                }
            });
        },

        initSituacaoChart() {
            const ctx = document.getElementById('situacaoChart');
            if (!ctx) return;

            if (this.situacaoChart) {
                this.situacaoChart.destroy();
            }

            const situacaoData = this.dashboardData.quantidadePorSitucao || {};
            const labels = Object.keys(situacaoData);
            const values = [];

            const colorMap = {
                'Ativo': {
                    background: 'rgba(75, 192, 192, 0.6)',
                    border: 'rgba(75, 192, 192, 1)'
                },
                'Inativo': {
                    background: 'rgba(255, 99, 132, 0.6)',
                    border: 'rgba(255, 99, 132, 1)'
                }
            };

            const backgroundColors = [];
            const borderColors = [];

            labels.forEach(label => {
                values.push(situacaoData[label]);

                if (colorMap[label]) {
                    backgroundColors.push(colorMap[label].background);
                    borderColors.push(colorMap[label].border);
                } else {
                    backgroundColors.push(this.chartColors[backgroundColors.length % this.chartColors.length]);
                    borderColors.push(this.chartBorderColors[borderColors.length % this.chartBorderColors.length]);
                }
            });

            const total = values.reduce((a, b) => (a || 0) + (b || 0), 0);
            const centerTextPlugin = {
                beforeDraw: (chart) => {
                    const { width, height, ctx } = chart.chart;
                    ctx.save();
                    const fontSize = (height / 180).toFixed(2);
                    ctx.font = `${fontSize}em Helvetica Neue, Arial, sans-serif`;
                    ctx.textBaseline = 'middle';
                    ctx.fillStyle = '#6c757d';
                    const text = total || 0;
                    const textX = Math.round((width - ctx.measureText(text).width) / 2);
                    const textY = height / 2;
                    ctx.fillText(text, textX, textY);
                    ctx.restore();
                }
            };

            this.situacaoChart = new Chart(ctx, {
                type: 'doughnut',
                data: {
                    labels: labels,
                    datasets: [{
                        data: values,
                        backgroundColor: backgroundColors,
                        borderColor: borderColors,
                        borderWidth: 1
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    cutoutPercentage: 70,
                    legend: { display: false },
                    tooltips: {
                        callbacks: {
                            label: (item, data) => {
                                const v = data.datasets[0].data[item.index] || 0;
                                const pct = total ? ((v / total) * 100).toFixed(1) : '0.0';
                                return `${data.labels[item.index]}: ${v} (${pct}%)`;
                            }
                        }
                    }
                },
                plugins: [centerTextPlugin]
            });
        },
        truncateLabel(value) {
            if (!value) return '';
            const max = 16;
            return String(value).length > max ? String(value).slice(0, max - 1) + '…' : value;
        },

        initProcessosCompraChart() {
            const ctx = document.getElementById('processosCompraChart');
            if (!ctx) return;

            if (this.processosCompraChart) {
                this.processosCompraChart.destroy();
            }

            const valorAtual = this.dashboardData.quantidadeProcessosCompraEmAndamento || 0;
            const data = Array(9).fill(valorAtual);

            this.processosCompraChart = new Chart(ctx, {
                type: 'line',
                data: {
                    labels: Array(data.length).fill(''),
                    datasets: [{
                        data: data,
                        borderColor: '#8862e0',
                        backgroundColor: 'rgba(136, 98, 224, 0.1)',
                        borderWidth: 2,
                        fill: true
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    elements: {
                        point: {
                            radius: 0
                        },
                        line: {
                            tension: 0.4
                        }
                    },
                    legend: {
                        display: false
                    },
                    scales: {
                        xAxes: [{
                            display: false
                        }],
                        yAxes: [{
                            display: false
                        }]
                    },
                    tooltips: {
                        enabled: false
                    }
                }
            });
        },

        initEmpenhoLineChart() {
            const ctx = document.getElementById('empenhoLineChart');
            if (!ctx) return;

            if (this.empenhoLineChart) {
                this.empenhoLineChart.destroy();
            }

            const valorAtual = this.dashboardData.quantidadeEmpenhoVigente || 0;
            const data = Array(9).fill(valorAtual);

            this.empenhoLineChart = new Chart(ctx, {
                type: 'line',
                data: {
                    labels: Array(data.length).fill(''),
                    datasets: [{
                        data: data,
                        borderColor: '#047edf',
                        backgroundColor: 'rgba(4, 126, 223, 0.1)',
                        borderWidth: 2,
                        fill: true
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    elements: {
                        point: {
                            radius: 0
                        },
                        line: {
                            tension: 0.4
                        }
                    },
                    legend: {
                        display: false
                    },
                    scales: {
                        xAxes: [{
                            display: false
                        }],
                        yAxes: [{
                            display: false
                        }]
                    },
                    tooltips: {
                        enabled: false
                    }
                }
            });
        },

        initValorLineChart() {
            const ctx = document.getElementById('valorLineChart');
            if (!ctx) return;

            if (this.valorLineChart) {
                this.valorLineChart.destroy();
            }

            const valorBase = this.dashboardData.valorTotalPatrimonio ?
                parseFloat(this.dashboardData.valorTotalPatrimonio) : 1000000;
            const data = [
                valorBase * 0.7,
                valorBase * 0.8,
                valorBase * 0.75,
                valorBase * 0.85,
                valorBase * 0.9,
                valorBase * 0.95,
                valorBase * 0.92,
                valorBase * 0.98,
                valorBase
            ];

            this.valorLineChart = new Chart(ctx, {
                type: 'line',
                data: {
                    labels: Array(data.length).fill(''),
                    datasets: [{
                        data: data,
                        borderColor: '#07cdae',
                        backgroundColor: 'rgba(7, 205, 174, 0.1)',
                        borderWidth: 2,
                        fill: true
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    elements: {
                        point: {
                            radius: 0
                        },
                        line: {
                            tension: 0.4
                        }
                    },
                    legend: {
                        display: false
                    },
                    scales: {
                        xAxes: [{
                            display: false
                        }],
                        yAxes: [{
                            display: false
                        }]
                    },
                    tooltips: {
                        enabled: false
                    }
                }
            });
        },
initItensLineChart() {
            const ctx = document.getElementById('itensLineChart');
            if (!ctx) return;

            if (this.itensLineChart) {
                this.itensLineChart.destroy();
            }

            const totalItens = this.getTotalQuantidadePorNaturezaDespesa();
            const data = [
                totalItens * 0.6,
                totalItens * 0.7,
                totalItens * 0.65,
                totalItens * 0.75,
                totalItens * 0.8,
                totalItens * 0.85,
                totalItens * 0.9,
                totalItens * 0.95,
                totalItens
            ];

            this.itensLineChart = new Chart(ctx, {
                type: 'line',
                data: {
                    labels: Array(data.length).fill(''),
                    datasets: [{
                        data: data,
                        borderColor: '#fe7096',
                        backgroundColor: 'rgba(254, 112, 150, 0.1)',
                        borderWidth: 2,
                        fill: true
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    elements: {
                        point: {
                            radius: 0
                        },
                        line: {
                            tension: 0.4
                        }
                    },
                    legend: {
                        display: false
                    },
                    scales: {
                        xAxes: [{
                            display: false
                        }],
                        yAxes: [{
                            display: false
                        }]
                    },
                    tooltips: {
                        enabled: false
                    }
                }
            });
        },
        formatCurrency(value) {
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(value || 0);
        }
    }
};
</script>

<style scoped lang="scss">
.patrimonio-dashboard {
    .page-title-header {
        margin-bottom: 1.5rem;

        .page-header {
            padding-bottom: 0;
            border-bottom: none;
            margin-bottom: 1.5rem;

            .page-title {
                font-weight: 500;
                font-size: 1.5rem;
                margin-bottom: 0.5rem;
            }

            .quick-links {
                list-style: none;
                padding-left: 0;
                display: flex;
                margin-bottom: 0;

                li {
                    display: inline-block;
                    margin-right: 1rem;

                    a {
                        color: #6c757d;
                        font-weight: 500;

                        &:hover {
                            color: #007bff;
                            text-decoration: none;
                        }
                    }
                }
            }
        }
    }

    .card {
        border-radius: 4px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
        margin-bottom: 1.5rem;

        .card-body {
            padding: 1.5rem;
        }

        .col-md-8.grid-margin.stretch-card .card-body,
        .col-md-4.grid-margin.stretch-card .card-body {
            min-height: 456px;
        }

        .card-title {
            font-weight: 500;
            margin-bottom: 1rem;
        }
    }

    .chart-container {
        position: relative;
        margin: auto;
    }

    .chartjs-legend {
        ul {
            list-style: none;
            padding-left: 0;
            display: flex;
            flex-wrap: wrap;

            li {
                display: flex;
                align-items: center;
                margin-right: 1rem;
                margin-bottom: 0.5rem;

                span {
                    display: inline-block;
                    width: 12px;
                    height: 12px;
                    margin-right: 0.5rem;
                    border-radius: 50%;
                }
            }
        }
    }

    .wrapper {
        min-height: auto !important;
        height: auto !important;
        position: relative;

        .font-weight-semibold {
            font-weight: 600;
        }

        .text-primary {
            color: #007bff !important;
        }

        .text-muted {
            color: #6c757d !important;
        }
    }

    .btn-outline-primary {
        color: #007bff;
        border-color: #007bff;

        &:hover {
            background-color: #007bff;
            color: #fff;
        }
    }
}

@media (max-width: 991px) {
  .patrimonio-dashboard .row > [class^="col-"] {
    margin-bottom: 1.2rem;
  }

  .patrimonio-dashboard .d-flex {
    flex-direction: column !important;
    align-items: stretch !important;
  }


  .patrimonio-dashboard .chart-container,
  .patrimonio-dashboard .chart-container canvas {
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .patrimonio-dashboard .chartjs-legend ul {
    flex-direction: column;
    align-items: flex-start;
  }
  .patrimonio-dashboard .chartjs-legend li {
    margin-right: 0;
    margin-bottom: 0.6rem;
  }
}

.patrimonio-dashboard #situacao-legend,
.patrimonio-dashboard .chartjs-legend {
  width: 100%;
  overflow-x: auto;
}

.patrimonio-dashboard .chart-container {
  max-width: 100%;
  min-width: 0;
  /* Não use width/height fixo inline em mobile */
}

.patrimonio-dashboard .d-flex {
  flex-wrap: nowrap;
    align-items: center;

}

.patrimonio-dashboard .wrapper {
  min-width: 0 !important;
  width: 100%;
  max-width: 100%;
overflow: hidden;

}


.patrimonio-dashboard .wrapper h3,
.patrimonio-dashboard .wrapper p {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  display: inline-block;
  vertical-align: top;
  cursor: pointer;
  transition: background 0.2s, box-shadow 0.2s;
  position: relative;
}

.patrimonio-dashboard .wrapper h3:hover,
.patrimonio-dashboard .wrapper p:hover {
  white-space: normal;
  overflow: visible;
  z-index: 10;
}


.patrimonio-dashboard .chart-container,
.patrimonio-dashboard .chart-container canvas {
  max-width: 100% !important;
  min-width: 0 !important;
  width: 100% !important;
}


</style>
